import request from './request'

/** 获取服务配置 */
export const getServicoConfig = () => {
  return request({
    url: '/carbon-misc/public/web/config/customer/service',
    method: 'GET'
  })
}

/** 获取安装配置 */
export const getInstallConfig = (options: any = {}) => {
  return request({
    url: '/carbon-misc/public/web/config/install/boot',
    method: 'GET',
    params: options
  }, {
    skipTime: 2000
  })
}

/** 获取app pwa */
export const getAppPwa = () => {
  return request({
    url: '/carbon-auth/private/user/center/user/install',
    method: 'GET',
  })
}


/** 获取防封配置 */
export const getAntiBlockConfig = (options: any = {}) => {
  return request({
    url: '/carbon-misc/public/domain/block/prevent',
    method: 'GET',
    params: options
  })
}

/** 获取webpush配置 */
export const getWebpushConfig = () => {
  return request({
    url: '/carbon-misc/public/web/config/web/push',
    method: 'GET'
  })
}

/** 获取图片基础地址 */
export const getMerchantConfig = () => {
  return request({
    url: '/carbon-auth/public/common/preload',
    method: 'GET'
  })
}

/** 获取图片基础地址 */
export const reportRedirect = () => {
  return request({
    url: '/carbon-auth/private/user/center/user/redirect',
    method: 'GET'
  })
}

/** 获取版本状态 */
export const getVersionStatus = () => {
  return request({
    url: '/carbon-misc/public/status/poll',
    method: 'GET',
  })
}

/** 获取一个新Token */
export const getNewToken = () => {
  return request({
    url: '/carbon-auth/private/user/center/token/refresh',
    method: 'GET'
  })
}